export const rules ={
        name: [
        { required: true, message: "请输入客服组名字", trigger: "blur" },
      ],
     
    }